import React from 'react';

import { fg } from '@confluence/feature-gating';

import { Bm3PageSegmentLoadEnd } from '../Bm3PageSegmentLoadEnd.tsx';
import type { Props } from '../Bm3PageSegmentLoadEnd.tsx';

import { UFOSegmentLoadEnd } from './UFOSegmentLoadEnd.tsx';

/**
 * Interop component that renders either the new UFOSegmentLoadEnd (which calls
 * addUFOCustomData directly) or the legacy Bm3PageSegmentLoadEnd (which feeds data
 * through BM3) based on the `confluence_fe_deprecate_bm3` feature gate.
 */
export const PageSegmentLoadEnd = (props: Props) => {
	if (fg('confluence_fe_deprecate_bm3')) {
		return <UFOSegmentLoadEnd {...props} />;
	}

	return <Bm3PageSegmentLoadEnd {...props} />;
};
